// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "select[data-v-f1435f24]{border:none}.UBCommonInputStyle[data-v-f1435f24]{border:1px solid #aaa;border-radius:5px;min-width:50px;width:50px;height:35px;box-sizing:border-box}textarea[data-v-f1435f24]{resize:none;min-height:80px;overflow:hidden}", ""]);
// Exports
module.exports = exports;
